import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationReportTemplate = createCrudVuexModule({
  namespaced: true,
  path: "/report-template",

  state: {
    downloadingItem: [],
  },
  getters: {
    isDownloading: (state) => (id) => {
      return !state.downloadingItem.indexOf(id);
    },
  },
  mutations: {
    addDownloadingItem: (state, id) => state.downloadingItem.push(id),
    removeDownloadingItem: (state, id) => {
      const index = state.downloadingItem.indexOf(id);
      state.downloadingItem.splice(index, 1);
    },
  },

  actions: {
    async prepare({ commit }, { id, saveInsteadofDownload, fileCategoryId, fileNo, admin, isPeriodical, period }) {
      commit("isUpdating", true);
      try {
        commit("addDownloadingItem", id);
        const response = await rest.post("/report-template/prepare/", { id, saveInsteadofDownload, fileCategoryId, fileNo, admin, isPeriodical, period });
        return response;
      } finally {
        commit("isUpdating", false);
        commit("removeDownloadingItem", id);
      }
    },
  },
});
